import { render, staticRenderFns } from "./CreateShiftAutomation.vue?vue&type=template&id=367cad9a&"
import script from "./CreateShiftAutomation.vue?vue&type=script&lang=ts&"
export * from "./CreateShiftAutomation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports